import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { getEmployeeNumberingSettings, updateEmployeeNumberingSettings } from '../../services/employeeNumberingSettingsService';
import { useAuth } from '../../context/AuthContext';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Button from '../../components/ui/Button';
import TextInput from '../../components/ui/TextInput.jsx';

const Wrapper = styled.div``;

const Card = styled.div`
  background: #fff;
  border-radius: 6px;
  padding: 28px;
  box-shadow: 0 1px 4px rgba(0, 66, 66, 0.06);
  max-width: 560px;
  margin-top: 16px;
`;

const Title = styled.h3`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 15px; font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 8px;
`;

const Description = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  color: #6B7280;
  margin: 0 0 20px;
`;

const Preview = styled.div`
  margin-top: 12px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.primary};
  span { font-weight: 700; }
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;

export default function EmployeeNumberingSettingsPage() {
  const { t } = useTranslation();
  const { canWrite } = useAuth();

  // Sunucudan gelene kadar boş; ilk yükleme değeri API'den gelir.
  const [prefix, setPrefix] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLoading(true);
    getEmployeeNumberingSettings()
      .then((res) => {
        const s = res.data?.data;
        // Boş ön ek GEÇERLİ bir değerdir — `if (s?.prefix)` boşu hiç uygulamıyor,
        // kutuda eski değer kalıyordu.
        if (s) setPrefix(s.prefix ?? '');
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = useCallback(async () => {
    setSaving(true);
    try {
      await updateEmployeeNumberingSettings({ prefix: (prefix || '').trim() });
    } catch { /* interceptor */ }
    setSaving(false);
  }, [prefix]);

  if (loading) return null;

  // Önizleme sunucudaki biçimlendirmenin aynısı: ön ek boşsa ayırıcı tire de yok.
  const trimmedPrefix = (prefix || '').trim();
  const sample = trimmedPrefix ? `${trimmedPrefix}-0001` : '0001';

  return (
    <Wrapper>
      <Breadcrumbs items={[{ label: t('employeeNumbering.title') }]} />
      <Card>
        <Title>{t('employeeNumbering.title')}</Title>
        <Description>{t('employeeNumbering.description')}</Description>
        <TextInput
          label={t('employeeNumbering.prefix')}
          value={prefix}
          onChange={(e) => setPrefix(e.target.value)}
          disabled={!canWrite('EM')}
        />
        <Preview>{t('employeeNumbering.preview')}: <span>{sample}</span></Preview>
        {canWrite('EM') && (
          <Actions>
            <Button onClick={handleSave} disabled={saving}>
              {saving ? '...' : t('common.save')}
            </Button>
          </Actions>
        )}
      </Card>
    </Wrapper>
  );
}
